module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/PlayIconDisabled.23dbf2a9.svg";